import React, { useMemo } from 'react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { es } from 'date-fns/locale';
import { createAppTheme } from './theme';
import router from './routes';
import { store, useAppSelector } from './store/store';
import AuthHydrate from './components/AuthHydrate';

function AppThemeShell({ children }: { children: React.ReactNode }) {
  const colorMode = useAppSelector((s) => s.ui.colorMode);
  const theme = useMemo(() => createAppTheme(colorMode), [colorMode]);
  return (
    <ThemeProvider theme={theme}>
      {children}
    </ThemeProvider>
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <AppThemeShell>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={es}>
          <CssBaseline />
          <AuthHydrate />
          <RouterProvider router={router} />
        </LocalizationProvider>
      </AppThemeShell>
    </Provider>
  );
}
